import React, { useEffect, useState } from 'react';
import KitLoader from '../../components/kitsters/KitLoader';
import TableItem from "./TableItem"
import { getdatanoauth, WAITINGGIF, sendwhatsappmessageapi } from '../../util/global';

const ItemNameCheck = () => {
  const [loading, setLoading] = useState(true);
  const [namecheckitemdata, setnamecheckitemdata] = useState([]);

  const params = new URLSearchParams(window.location.search);
  const fetchdata = async () => {
    const adminuserid = window.APPUSER?.user?.token ? window.APPSETTING.adminuserid : params.get('adminuserid');

    let data = await getdatanoauth({ zohodatatype: 'items', _adminuserid: adminuserid, tag:"checkname" }, '/zohodatanoauth');
    setnamecheckitemdata(data.data);
    setLoading(false);
  };

  useEffect(() => {
   fetchdata();
  }, []);

  return (

    <div className="content-area" style={{ position: 'relative', minHeight: 'calc(100vh - 140px)' }}>
      {loading && <KitLoader />}

      <h3 style={{ marginBottom: '16px' }}>Name Check | Problem Count: {namecheckitemdata.length} </h3>
      <TableItem itemdata={namecheckitemdata} />

    </div>
  );
};

export default ItemNameCheck;
